import { BrandPhilosophy, Milestone, BrandPillar } from '../types/brand.types';

export const BRAND_PHILOSOPHY: BrandPhilosophy = {
  description: "En ZWheel, no solo fabricamos patinetes eléctricos; creamos soluciones de movilidad que transforman la manera en que interactúas con tu ciudad. Nuestra pasión es la innovación constante para ofrecerte libertad, seguridad y eficiencia en cada trayecto.",
  ceoQuote: "Creemos en un futuro donde la movilidad urbana sea limpia, eficiente y accesible para todos. Cada producto ZWheel es un paso hacia ese horizonte.",
  values: [
    {
      id: 'security',
      title: 'Seguridad',
      subtitle: 'Seguridad Certificada',
      description: 'Tu seguridad es nuestra prioridad. Cumplimos con los más altos estándares europeos.',
      icon: 'ShieldCheck'
    },
    {
      id: 'technology',
      title: 'Tecnología',
      subtitle: 'Tecnología Avanzada',
      description: 'Innovación constante en baterías, motores y sistemas de control inteligente.',
      icon: 'Cpu'
    },
    {
      id: 'sustainability',
      title: 'Sostenibilidad',
      subtitle: 'Sostenibilidad Eléctrica',
      description: 'Comprometidos con el medio ambiente, reduciendo la huella de carbono kilómetro a kilómetro.',
      icon: 'Leaf'
    },
    {
      id: 'rider',
      title: 'Rider',
      subtitle: 'Compromiso Rider',
      description: 'Diseñamos pensando en ti, el conductor, para ofrecerte la mejor experiencia de viaje.',
      icon: 'User'
    }
  ]
};

export const BRAND_MILESTONES: Milestone[] = [
  { year: '2019', content: 'Fundación de ZWheel en Barcelona, iniciando la revolución de la movilidad.' },
  { year: '2020', content: 'Lanzamiento de la primera serie ZLion, éxito de ventas en España.' },
  { year: '2021', content: 'Expansión al mercado europeo y apertura de nuevos centros logísticos.' },
  { year: '2022', content: 'Introducción de la tecnología de baterías HPB y mejora de la autonomía.' },
  { year: '2023', content: 'Lanzamiento de la serie ZFox, redefiniendo la movilidad urbana ligera.' },
  { year: '2024', content: 'Presentación de la gama ZWolf y ZCougar, conquistando el segmento premium y off-road.' },
  { year: '2025', content: 'Consolidación como líderes en movilidad eléctrica con más de 100.000 usuarios.' }
];

export const BRAND_PILLARS: BrandPillar[] = [
  {
    id: 'security',
    label: 'Seguridad',
    description: 'Certificada',
    icon: 'ShieldCheck'
  },
  {
    id: 'tech',
    label: 'Tecnología',
    description: 'Avanzada',
    icon: 'Zap'
  },
  {
    id: 'eco',
    label: 'Sostenibilidad',
    description: 'Eléctrica',
    icon: 'Leaf'
  },
  {
    id: 'rider',
    label: 'Rider',
    description: 'Compromiso',
    icon: 'User'
  }
];
